import { Accept } from 'react-dropzone';
import { CompressionOptions } from 'types/file';

export const ARCHIVE_FILE_TYPES = ['.zip'];
export const EXCEL_FILE_TYPES = ['.xlsx', '.xlsm', '.xlsb', '.xls', '.csv'];
export const IMAGE_FILE_TYPES = [
  '.jpg',
  '.png',
  '.jpeg',
  '.svg',
  '.webp',
  '.heic',
  '.heif',
];

export const DOC_FILE_TYPES = ['.docx', '.docm', '.doc', '.txt'];
export const PDF_FILE_TYPES = ['.pdf'];
export const VIDEO_FILE_TYPES = [
  '.mp4',
  '.mov',
  '.avi',
  '.mpg',
  '.wmv',
  '.ogg',
  '.webm',
];

export const BLOCKED_FILE_TYPES = ['.apk', '.exe'];

export const ACCEPT_EXCEL_FILE_FORMAT: Accept = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    EXCEL_FILE_TYPES,
  'application/vnd.ms-excel.sheet.macroEnabled.12': EXCEL_FILE_TYPES,
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12': EXCEL_FILE_TYPES,
  'application/vnd.ms-excel': EXCEL_FILE_TYPES,
  'text/csv': EXCEL_FILE_TYPES,
};

export const EXCEL_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const ACCEPT_IMAGE_FILE_FORMAT: Accept = {
  'image/*': IMAGE_FILE_TYPES,
};

export const ACCEPT_DOC_FILE_FORMAT: Accept = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    DOC_FILE_TYPES,
  'application/msword': DOC_FILE_TYPES,
  'text/plain': DOC_FILE_TYPES,
};

export const ACCEPT_PDF_FILE_FORMAT: Accept = {
  'application/pdf': PDF_FILE_TYPES,
};

export const ACCEPT_VIDEO_FILE_FORMAT: Accept = {
  'video/*': VIDEO_FILE_TYPES,
};

export const ACCEPT_IMAGE_AND_PDF_FILE_FORMAT: Accept = {
  ...ACCEPT_IMAGE_FILE_FORMAT,
  ...ACCEPT_PDF_FILE_FORMAT,
};

export const ACCEPT_ALL_FILE_FORMAT: Accept = {
  ...ACCEPT_EXCEL_FILE_FORMAT,
  ...ACCEPT_IMAGE_FILE_FORMAT,
  ...ACCEPT_DOC_FILE_FORMAT,
  ...ACCEPT_PDF_FILE_FORMAT,
  ...ACCEPT_VIDEO_FILE_FORMAT,
};

export const DEFAULT_COMPRESSION_OPTIONS: CompressionOptions = {
  maxSizeMB: 2, // Default 1MB max size
  maxWidthOrHeight: 1920, // Default max dimension
  useWebWorker: true, // Use web worker for non-blocking compression
  initialQuality: 0.7, // Start with 70% quality for 30% reduction
  minSizeForCompressionInMB: 2, // @MJ: 2MB min size for compression
};

export const EXCEL_CONTENT_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const PROJECT_IMPORT_SAMPLE_FILENAME = 'project_import_template.xlsx';

export const VALID_EXCEL_FILE_TYPES = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  'application/vnd.ms-excel',
  'text/csv',
];
